import { gql } from '@apollo/client';
import {
  CommonLocalizableString,
  CommonLocalizableVideo,
  CommonLocalizableImage,
  CommonLocalizableFile,
} from 'network/common/cmsFragment';
import { fetchAllPage } from 'network/common/cmsUtils';
import ColorFillElementFragment from './common/boothDesign/colorFillElementFragment';
import ContentAreaElementFragment from './common/boothDesign/contentAreaElementFragment';
import ImageElementFragment from './common/boothDesign/imageElementFragment';
import ImageButtonElementFragment from './common/boothDesign/imageButtonElementFragment';
import MeasurementFragment from './common/boothDesign/measurementFragment';
import CommonDesignElementFragment from './common/boothDesign/commonDesignElementFragment';

interface FetchBoothDesignCanvasByIdProps {
  boothId: string;
  locales: string[];
}

const fetchBoothDesignCanvasByIdQuery = gql`
  query fetchBoothDesignCanvasById(
    $boothId: ID!
    $locales: [Locale!]!
    $cursor: String
    $count: Int
  ) {
    node(id: $boothId) {
      ... on Booth {
        id
        boothDesignCanvas {
          ...CommonV2DesignElement
          maxWidth {
            ...Measurement
          }
          aspectRatio {
            ...Measurement
          }
          layers (after: $cursor, first: $count) {
            pageInfo {
              hasNextPage
              endCursor
            }
            nodes {
              ...CommonV2DesignElement
              ...ColorFillElement
              ...ContentAreaElement
              ...ImageElement
              ...ImageButtonElement
              __typename
              ... on BoothDesignCustomizableElement {
                keyName
              }
            }
          }
        }
      }
    }
  }
  ${CommonLocalizableString}
  ${CommonLocalizableVideo}
  ${CommonLocalizableImage}
  ${CommonLocalizableFile}
  ${ColorFillElementFragment}
  ${ContentAreaElementFragment}
  ${ImageElementFragment}
  ${ImageButtonElementFragment}
  ${MeasurementFragment}
  ${CommonDesignElementFragment}
`;

const fetchBoothDesignCanvasById = async (input: FetchBoothDesignCanvasByIdProps) => {
  const pages = await fetchAllPage((data: any) => data.node.boothDesignCanvas.layers.pageInfo, fetchBoothDesignCanvasByIdQuery, {
    ...input,
    count: 20,
  });

  const boothDesignCanvasLayers = pages
    .reduce((sum, data) => [...sum, ...(data.node.boothDesignCanvas.layers.nodes || [])], []);

  const result = {
    id: pages[0].node.id,
    boothDesignCanvas: {
      ...pages[0].node.boothDesignCanvas,
      layers: {
        nodes: boothDesignCanvasLayers,
      },
    },
  };
  return result;
};

export default fetchBoothDesignCanvasById;
